const Home = () => {
  return (
    <div class="container">
      <h2>Welcome innit</h2>
    </div>
  );
};

export default Home;
